var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chat)?_c('div',{class:_vm.$style.circle,style:(_vm.wrapperStyle)},[(_vm.chat.imgLink)?_c('img',{class:_vm.$style.image,attrs:{"src":_vm.chat.imgLink,"alt":"chat photo"}}):[_vm._v(_vm._s(_vm.placeholder))]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }